import React from 'react'
import useLogEvent from 'amplitude/useLogEvent'
import useSendDataToGTM from 'utils/useSendDataToGTM'
import { MONEY_BACK_GUARANTEE_DAYS } from 'utils/moneyBackGuarantee'

const MoneyBackGuaranteeBadge = () => {
  const logEvent = useLogEvent()
  const sendDataToGTM = useSendDataToGTM()
  const moneyBackGuaranteeDays = MONEY_BACK_GUARANTEE_DAYS
  const defaultHelpdeskUrl = process.env.REACT_APP_HELPCENTER_MBG_ARTICLE

  const logClick = () => {
    const params = { moneyBackGuaranteeDays }
    logEvent('Click Money Back Guarantee', params)
    sendDataToGTM('click-money-back-guarantee', params)
  }

  return (
    <a
      href={defaultHelpdeskUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={logClick}
      style={{ display: 'flex' }}
    >
      <img
        src="/icon_moneyback_guarantee.png"
        alt={`${moneyBackGuaranteeDays}-day Money-Back Guarantee`}
        width={154}
        height={50}
      />
    </a>
  )
}

export default MoneyBackGuaranteeBadge
